import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7171215c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Sidebar__inner" }
const _hoisted_2 = {
  key: 0,
  class: "logo__text"
}
const _hoisted_3 = { class: "Sidebar__links" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book fa-sm link__icon" }, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "link__name"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 2,
  class: "link__name"
}
const _hoisted_8 = {
  key: 3,
  class: "p-1 rounded bg-blue-500 text-blue-100 text-xs ml-3"
}
const _hoisted_9 = {
  key: 1,
  class: "links__parent"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 2,
  class: "trigger__name"
}
const _hoisted_12 = {
  key: 3,
  class: "p-1 rounded bg-blue-500 text-blue-100 text-xs ml-3"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 2,
  class: "child__name"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sidebar_link_with_tooltip = _resolveComponent("sidebar-link-with-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['Sidebar', { 'Sidebar-closed': !_ctx.isOpened }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.getLogoClass)
      }, [
        (_ctx.isOpened)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.getLogoText), 1))
          : _createCommentVNode("", true),
        (_ctx.isOpened)
          ? (_openBlock(), _createElementBlock("i", {
              key: 1,
              class: "fas fa-outdent fa-lg logo__icon",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
            }))
          : (_openBlock(), _createElementBlock("i", {
              key: 2,
              class: "fas fa-bars fa-lg logo__icon",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
            }))
      ], 2),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayed_links, (link) => {
          return (_openBlock(), _createElementBlock("div", {
            key: link.id
          }, [
            (!link.sub_links.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (link.isOther)
                    ? (_openBlock(), _createBlock(_component_sidebar_link_with_tooltip, {
                        key: 0,
                        class: _normalizeClass(['links__link', { 'links__link-closed': !_ctx.isOpened }]),
                        href: link.url,
                        "tooltip-content": link.name,
                        "is-sidebar-closed": !_ctx.isOpened,
                        component: "a",
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4,
                          (_ctx.isOpened)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(link.name), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["class", "href", "tooltip-content", "is-sidebar-closed"]))
                    : (_openBlock(), _createBlock(_component_sidebar_link_with_tooltip, {
                        key: 1,
                        class: _normalizeClass(['links__link', { 'links__link-closed': !_ctx.isOpened }]),
                        to: link.url,
                        "tooltip-content": link.name,
                        "is-sidebar-closed": !_ctx.isOpened
                      }, {
                        default: _withCtx(() => [
                          (link.icon_custom)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: `/icons/${link.icon_custom}`,
                                alt: "icon_custom",
                                class: "icon_custom"
                              }, null, 8, _hoisted_6))
                            : (_openBlock(), _createElementBlock("i", {
                                key: 1,
                                class: _normalizeClass(link.icon)
                              }, null, 2)),
                          (_ctx.isOpened)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(link.name), 1))
                            : _createCommentVNode("", true),
                          (_ctx.isOpened && link.is_beta)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, " BETA "))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["class", "to", "tooltip-content", "is-sidebar-closed"]))
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_sidebar_link_with_tooltip, {
                    component: "div",
                    "tooltip-content": link.name,
                    "is-sidebar-closed": !_ctx.isOpened,
                    class: _normalizeClass([
                                    'parent__trigger',
                                    { 'parent__trigger-closed': !_ctx.isOpened },
                                ]),
                    onClick: ($event: any) => (_ctx.openParent(link.id))
                  }, {
                    default: _withCtx(() => [
                      (link.icon_custom)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: `/icons/${link.icon_custom}`,
                            alt: "icon_custom",
                            class: "icon_custom"
                          }, null, 8, _hoisted_10))
                        : (_openBlock(), _createElementBlock("i", {
                            key: 1,
                            class: _normalizeClass(link.icon)
                          }, null, 2)),
                      (_ctx.isOpened)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(link.name), 1))
                        : _createCommentVNode("", true),
                      (_ctx.isOpened && link.is_beta)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, " BETA "))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["tooltip-content", "is-sidebar-closed", "class", "onClick"]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["parent__childs", { 'parent--opened': link.id === _ctx.opened_parent }])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(link.sub_links, (sub_link) => {
                      return (_openBlock(), _createBlock(_component_sidebar_link_with_tooltip, {
                        class: "childs__link",
                        key: sub_link.id,
                        to: sub_link.url,
                        "tooltip-content": sub_link.name,
                        "is-sidebar-closed": !_ctx.isOpened
                      }, {
                        default: _withCtx(() => [
                          (sub_link.icon_custom)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: `/icons/${sub_link.icon_custom}`,
                                alt: "icon_custom",
                                class: "icon_custom"
                              }, null, 8, _hoisted_13))
                            : (_openBlock(), _createElementBlock("i", {
                                key: 1,
                                class: _normalizeClass(sub_link.icon)
                              }, null, 2)),
                          (_ctx.isOpened)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(sub_link.name), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["to", "tooltip-content", "is-sidebar-closed"]))
                    }), 128))
                  ], 2)
                ]))
          ]))
        }), 128)),
        (_ctx.havePermissions(['base-page.view']))
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_component_sidebar_link_with_tooltip, {
                component: "a",
                class: _normalizeClass(['links__link', { 'links__link-closed': !_ctx.isOpened }]),
                "is-sidebar-closed": !_ctx.isOpened,
                "tooltip-content": "Портал поддержки",
                href: "https://dostavka.atlassian.net/servicedesk/customer/portals",
                rel: "nofollow, noreferrer",
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _hoisted_16,
                  (_ctx.isOpened)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["link__name", _ctx.isOpened ? 'link__name' : 'link__name-closed'])
                      }, " Портал поддержки ", 2))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["class", "is-sidebar-closed"]),
              _createVNode(_component_sidebar_link_with_tooltip, {
                component: "a",
                class: _normalizeClass(['links__link', { 'links__link-closed': !_ctx.isOpened }]),
                "is-sidebar-closed": !_ctx.isOpened,
                "tooltip-content": "База знаний",
                href: "https://dostavka.atlassian.net/servicedesk/customer/portal/3/article/30081230",
                rel: "nofollow, noreferrer",
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _hoisted_17,
                  (_ctx.isOpened)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["link__name", _ctx.isOpened ? 'link__name' : 'link__name-closed'])
                      }, " База знаний ", 2))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["class", "is-sidebar-closed"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}